import { apiFetch } from "../auth/api";

export interface ApiError { code: string; message: string }

async function parse<T>(res: Response): Promise<T> {
  const text = await res.text();
  let body: unknown = null;
  try { body = text ? JSON.parse(text) : null; } catch { body = text; }
  if (!res.ok) {
    const e = (body as { error?: ApiError })?.error;
    throw new Error(e?.message || `Request failed (${res.status})`);
  }
  return body as T;
}

export function get<T>(path: string): Promise<T> {
  return apiFetch(path).then((r) => parse<T>(r));
}

let idem = 0;
export function send<T>(method: "POST" | "PATCH", path: string, body?: unknown, idempotent = false): Promise<T> {
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (idempotent) headers["Idempotency-Key"] = `web-${Date.now()}-${idem++}`;
  return apiFetch(path, { method, headers, body: JSON.stringify(body ?? {}) }).then((r) => parse<T>(r));
}

// del removes a record by path (DELETE). Resolves on 2xx, throws otherwise.
export async function del(path: string): Promise<void> {
  const res = await apiFetch(path, { method: "DELETE" });
  if (!res.ok) await parse(res);
}

// entityRows fetches rows from the generic entity endpoint.
export async function entityRows<T = Record<string, unknown>>(entity: string, limit = 200): Promise<T[]> {
  const d = await get<{ data: T[] }>(`/api/v1/entities/${entity}?limit=${limit}`);
  return d.data || [];
}
